'use client'
import { usePathname, useSearchParams } from 'next/navigation'

export function useUrl() {
  const pathname = usePathname()
  const searchParamsString = useSearchParams()?.toString() ?? ''
  const url = `${pathname}${searchParamsString ? `?${searchParamsString}` : ''}`
  return url
}
